var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDelete',{ref:"baseDelete",attrs:{"entry":_vm.entry,"deleteTitle":"Deleção de Região","formErrors":_vm.formErrors},on:{"delete-confirm-action":_vm.destroyEntry}},[_c('p',[_vm._v(" Você tem certeza que deseja deletar esta região?")])])}
var staticRenderFns = []

export { render, staticRenderFns }